/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedPropertyRequest
 */
export interface APIPatchedPropertyRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedPropertyRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedPropertyRequest
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedPropertyRequest
     */
    type?: string;
}

/**
 * Check if a given object implements the APIPatchedPropertyRequest interface.
 */
export function instanceOfAPIPatchedPropertyRequest(value: object): value is APIPatchedPropertyRequest {
    return true;
}

export function APIPatchedPropertyRequestFromJSON(json: any): APIPatchedPropertyRequest {
    return APIPatchedPropertyRequestFromJSONTyped(json, false);
}

export function APIPatchedPropertyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedPropertyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'] == null ? undefined : json['value'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function APIPatchedPropertyRequestToJSON(value?: APIPatchedPropertyRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
        'type': value['type'],
    };
}

